import { render, staticRenderFns } from "./jdalDetails.vue?vue&type=template&id=6ef4d9bd&scoped=true"
import script from "./jdalDetails.vue?vue&type=script&lang=js"
export * from "./jdalDetails.vue?vue&type=script&lang=js"
import style0 from "./jdalDetails.vue?vue&type=style&index=0&id=6ef4d9bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef4d9bd",
  null
  
)

export default component.exports